// extracted by mini-css-extract-plugin
module.exports = {"bundles":"JP_bundles__2kaL9"};